class CarPhotoUpload {
  constructor(element) {
    this.element = element;
    this.maxFileSize = Number(element.dataset.maxFileSize || 10485760);
    this.items = Array.from(element.querySelectorAll('[data-photo-item]'));
    this.grid = element.querySelector('[data-photo-grid]');
    this.addButton = element.querySelector('[data-add-photo]');
    this.status = element.querySelector('[data-photo-status]');

    this.items.forEach((item) => this.bindItem(item));
    this.addButton?.addEventListener('click', () => this.revealNextPhoto());
    this.updateProgressiveState();
  }

  bindItem(item) {
    const input = item.querySelector('[data-photo-input]');
    const removeButton = item.querySelector('[data-remove-photo]');
    input.addEventListener('change', () => this.showFile(item, input));
    removeButton.addEventListener('click', () => this.clearFile(item, input));
  }

  showFile(item, input) {
    const file = input.files && input.files[0];
    if (!file) return this.clearFile(item, input);
    if (!file.type.startsWith('image/')) return this.rejectFile(item, input, 'Please choose an image file.');
    if (file.size > this.maxFileSize) return this.rejectFile(item, input, this.element.dataset.sizeError);

    input.setCustomValidity('');
    const image = new Image();
    image.alt = '';
    image.src = URL.createObjectURL(file);
    image.onload = () => URL.revokeObjectURL(image.src);
    item.querySelector('[data-photo-preview]').replaceChildren(image);
    item.querySelector('[data-file-name]').textContent = file.name;
    item.querySelector('[data-remove-photo]').hidden = false;
    item.classList.add('has-photo');
    this.updateProgressiveState();
  }

  rejectFile(item, input, message) {
    input.value = '';
    input.setCustomValidity(message);
    input.reportValidity();
    window.setTimeout(() => input.setCustomValidity(''), 0);
    item.classList.remove('has-photo');
  }

  clearFile(item, input) {
    input.value = '';
    input.setCustomValidity('');
    item.querySelector('[data-photo-preview]').replaceChildren();
    item.querySelector('[data-file-name]').textContent = input.required ? 'Required' : 'Optional';
    item.querySelector('[data-remove-photo]').hidden = true;
    item.classList.remove('has-photo');

    if (item !== this.items[0]) item.hidden = true;
    this.updateProgressiveState();
  }

  revealNextPhoto() {
    const nextItem = this.items.find((item) => item.hidden);
    if (!nextItem) return;

    nextItem.hidden = false;
    this.updateProgressiveState();
    nextItem.querySelector('[data-photo-input]')?.click();
  }

  updateProgressiveState() {
    const visibleItems = this.items.filter((item) => !item.hidden);
    const photoCount = this.items.filter((item) => item.classList.contains('has-photo')).length;

    if (this.grid) this.grid.dataset.visibleCount = String(visibleItems.length);
    if (this.addButton) this.addButton.hidden = !this.items.some((item) => item.hidden);
    if (this.status) {
      this.status.textContent = `${photoCount} ${photoCount === 1 ? 'photo' : 'photos'} added. ${this.items.length} maximum.`;
    }
  }
}

const initializeCarPhotoUploads = (root = document) => {
  root.querySelectorAll('[data-car-photo-upload]:not([data-initialized])').forEach((element) => {
    element.dataset.initialized = 'true';
    new CarPhotoUpload(element);
  });
};

initializeCarPhotoUploads();
document.addEventListener('shopify:section:load', (event) => initializeCarPhotoUploads(event.target));
